var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 13 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    fillRule: "evenodd",
    d: "M12.233.528c.26.26.26.683 0 .943L4.9 8.804a.667.667 0 0 1-.943 0L.624 5.471a.667.667 0 0 1 .943-.943L4.429 7.39 11.29.528c.26-.26.682-.26.942 0",
    clipRule: "evenodd"
  })));
};
export default SvgCheckMark;